import { getUniqueId } from '@/utils/misc'

import { KODE_WILAYAH_NASIONAL_FOR_TRACKER } from '@/modules/DataInduk/provinces'

import { sendTrackerGA } from '../gaTracker'
import { sendTrackerSatuEvent } from '../satuTracker'
import {
  LocationLevel,
  TrackerSection,
  TrackerSectionType,
  TrackerSubSection,
  TrackerSubSectionType,
} from '../shared'

export const trackViewDataIndukNasional = ({
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'PAGE_VIEWED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - Nasional - ${KODE_WILAYAH_NASIONAL_FOR_TRACKER}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'PAGE_VIEWED',
    eventParams: {
      section: section,
      sub_section: subSection,
      location_id: KODE_WILAYAH_NASIONAL_FOR_TRACKER,
      location_level: 'Nasional',
    },
  })
}

export const trackViewDataIndukProvince = ({
  provinceId,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  provinceId: string
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'PAGE_VIEWED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - Provinsi - ${provinceId}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'PAGE_VIEWED',
    eventParams: {
      section: section,
      sub_section: subSection,
      location_id: provinceId,
      location_level: 'Provinsi',
    },
  })
}

export const trackViewDataIndukKabKot = ({
  kabKotId,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  provinceId: string
  kabKotId: string
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'PAGE_VIEWED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - Kabupaten - ${kabKotId}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'PAGE_VIEWED',
    eventParams: {
      section: section,
      sub_section: subSection,
      location_id: kabKotId,
      location_level: 'Kabupaten',
    },
  })
}

export const trackViewDataIndukKecamatan = ({
  kecamatanId,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  provinceId: string
  kabKotId: string
  kecamatanId: string
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'PAGE_VIEWED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - Kecamatan - ${kecamatanId}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'PAGE_VIEWED',
    eventParams: {
      section: section,
      sub_section: subSection,
      location_id: kecamatanId,
      location_level: 'Kecamatan',
    },
  })
}

export const trackViewDataIndukSearchResult = ({
  keyword,
  locationId,
  locationLevel,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  keyword: string
  locationId: string
  locationLevel: LocationLevel
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  if (keyword !== '') {
    const trackerId = getUniqueId()
    sendTrackerGA({
      id: trackerId,
      eventName: 'induk',
      eventAction: 'SEARCH_BUTTON_CLICKED',
      eventParams: {
        eventLabel: `${section} - ${subSection} - ${keyword} - ${locationLevel} - ${locationId}`,
      },
    })

    sendTrackerSatuEvent({
      id: trackerId,
      pageTitle: 'Data Induk',
      activityType: 'SEARCH_BUTTON_CLICKED',
      eventParams: {
        section: section,
        sub_section: subSection,
        keyword,
        location_id: locationId,
        location_level: locationLevel,
      },
    })
  }
}

export const trackTypeLocalSearch = ({
  keyword,
  locationId,
  locationLevel,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  keyword: string
  locationId: string
  locationLevel: LocationLevel
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  if (keyword !== '') {
    const trackerId = getUniqueId()
    sendTrackerGA({
      id: trackerId,
      eventName: 'induk',
      eventAction: 'SEARCH_BUTTON_CLICKED',
      eventParams: {
        eventLabel: `${section} - ${subSection} - ${keyword} - ${locationLevel} - ${locationId}`,
      },
    })

    sendTrackerSatuEvent({
      id: trackerId,
      pageTitle: 'Data Induk',
      activityType: 'SEARCH_BUTTON_CLICKED',
      eventParams: {
        section: section,
        sub_section: subSection,
        keyword,
        location_id: locationId,
        location_level: locationLevel,
      },
    })
  }
}

export const trackClickDetailNpsn = ({
  npsn,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  npsn: string
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'NPSN_DETAIL_OPENED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - ${npsn}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'NPSN_DETAIL_OPENED',
    eventParams: {
      reference_id: npsn,
      section: section,
      sub_section: subSection,
    },
  })
}

export const GENDER_MAPPING = {
  laki: 'L',
  perempuan: 'P',
}

export const JENIS_PTK_MAPPINGS = {
  pendidik: 'Guru',
  tendik: 'Pegawai',
}

export const trackClickApplyFilters = ({
  locationId,
  locationLevel,
  jalur,
  bentuk,
  status,
  jenis,
  kelamin,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
}: {
  locationId: string
  locationLevel: LocationLevel
  jalur?: string
  bentuk?: string
  status?: string
  jenis?: string
  kelamin?: string
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'PAGE_FILTER_APPLIED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - ${locationLevel} - ${locationId} - ${
        jalur || 'semua'
      } - ${bentuk || 'semua'} - ${status || 'semua'} - ${jenis || 'semua'} - ${kelamin || 'semua'}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'PAGE_FILTER_APPLIED',
    eventParams: {
      section: section,
      sub_section: subSection,
      location_id: locationId,
      location_level: locationLevel,
      jalur: jalur || 'semua',
      bentuk: bentuk || 'semua',
      status: status || 'semua',
      jenis: jenis || 'semua',
      kelamin: kelamin || '',
    },
  })
}

export const trackClickOpenVervalByNpyp = ({ npyp }: { npyp: string }) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'NPYP_DETAIL_OPENED',
    eventParams: {
      eventLabel: `${npyp}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'NPYP_DETAIL_OPENED',
    eventParams: {
      reference_id: npyp,
    },
  })
}

export const trackClickSekolahNaungan = ({ npyp }: { npyp: string }) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'AGG_DETAIL_OPENED',
    eventParams: {
      eventLabel: `${npyp}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'AGG_DETAIL_OPENED',
    eventParams: {
      reference_id: npyp,
      section: 'Sekolah Naungan',
    },
  })
}

export const trackClickDownloadDataInduk = ({
  locationId,
  locationLevel,
  jalur,
  bentuk,
  status,
  jenis,
  kelamin,
  section = TrackerSection.SATPEN,
  subSection = TrackerSubSection.PAUD_DIKDASMEN,
  keyword = '',
  format,
}: {
  locationId: string
  locationLevel: LocationLevel
  jalur?: string
  bentuk?: string
  status?: string
  jenis?: string
  kelamin?: string
  section?: TrackerSectionType
  subSection?: TrackerSubSectionType
  keyword?: string
  format: 'xlsx' | 'csv' | 'pdf'
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'induk',
    eventAction: 'DOWNLOAD_BUTTON_CLICKED',
    eventParams: {
      eventLabel: `${section} - ${subSection} - ${locationLevel} - ${locationId} - ${format} - ${
        jalur || 'semua'
      } - ${bentuk || 'semua'} - ${status || 'semua'} - ${jenis || 'semua'} - ${kelamin || 'semua'} - ${keyword || 'nil'}`,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Data Induk',
    activityType: 'DOWNLOAD_BUTTON_CLICKED',
    eventParams: {
      section: section,
      sub_section: subSection,
      location_id: locationId,
      location_level: locationLevel,
      jalur: jalur || 'semua',
      bentuk: bentuk || 'semua',
      status: status || 'semua',
      jenis: jenis || 'semua',
      kelamin: kelamin || '',
      keyword,
      format,
    },
  })
}
